/**
 * @property manager {RepositoryManager}
 */
export default class IRepository {
    /**
     * Constructor
     * @param manager {RepositoryManager}
     * @param module {string}
     */
    constructor(manager, module) {
        this.manager = manager
        this.module = module ? module.toString() + '/' : '';
    }

    /**
     * Scoped action call
     * @param action {string}
     * @param [payload] {*}
     * @param [options] {*}
     * @returns {Promise<*>}
     */
    async dispatch(action, payload, options) {
        return this.manager.store.dispatch(
            this.module + action.toString(),
            payload,
            options
        );
    }

    /**
     * Scoped getters
     * @param name {string}
     * @returns {*}
     */
    getters(name) {
        return this.manager.store.getters[this.module + name];
    }
}